<script lang="ts">
  import { imgSrc } from '#app/lib/image_source'
  import { loadInternalLink, objectEntries } from '#app/lib/utils'
  import { getYearFromSimpleDay, type SerializedEntity } from '#entities/lib/entities'
  import { extendedAuthorsKeys } from '#entities/lib/types/author_alt'
  import type { PropertyUri } from '#server/types/entity'
  import { I18n } from '#user/lib/i18n'

  const {
    authorsByProperty,
  }: {
    authorsByProperty: Record<PropertyUri, SerializedEntity[]>
  } = $props()
</script>

{#each objectEntries(authorsByProperty) as [ property, authors ] (property)}
  {@const { singular, plural } = extendedAuthorsKeys[property]}
  {#if authors.length > 0}
    <div class="section-label {plural}">
      {#if authors.length === 1}
        <p class="section-label">{I18n(singular)}</p>
      {:else}
        <p class="section-label">{I18n(plural)}</p>
      {/if}
      <ul>
        {#each authors as author (author.uri)}
          <li class="author-preview">
            <a
              href={author.pathname}
              title={author.label}
              onclick={loadInternalLink}
            >
              <!-- using an image larger that what is displayed so that background cover scale up doesn't make the image pixelized -->
              {#if author.image?.url}
                <div class="image" style:background-image="url({imgSrc(author.image.url, 90)})"></div>
              {/if}
              <div class="summary-data">
                <span class="name" lang={author.labelLang}>{author.label}</span>
                {#if author.claims?.['wdt:P569']?.[0]}
                  <p class="birth-death-dates">
                    <span class="date">{getYearFromSimpleDay(author.claims['wdt:P569'][0])}</span>
                    -
                    {#if author.claims['wdt:P570']?.[0]}
                      <span class="date">{getYearFromSimpleDay(author.claims['wdt:P570'][0])}</span>
                    {/if}
                  </p>
                {/if}
              </div>
            </a>
          </li>
        {/each}
      </ul>
    </div>
  {/if}
{/each}

<style lang="scss">
  @import "general/scss/utils";
  .author-preview a{
    @include radius;
    @include display-flex(row, center, flex-start);
    margin: 0.2em 0;
    @include bg-hover-svelte(#f3f3f3);
    .image{
      width: 64px;
      height: 64px;
      background-size: cover;
      background-position: center center;
      @include radius-left;
    }
    .summary-data{
      margin: 0 auto;
      text-align: center;
      .name{
        line-height: 1.2em;
        font-weight: bold;
      }
      .birth-death-dates{
        line-height: 1em;
      }
    }
  }
</style>
